import { render, staticRenderFns } from "./SalesOrderPage.vue?vue&type=template&id=702c1c50&scoped=true&"
import script from "./SalesOrderPage.vue?vue&type=script&lang=js&"
export * from "./SalesOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderPage.vue?vue&type=style&index=0&id=702c1c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c1c50",
  null
  
)

export default component.exports